// Tier color configurations
export const tierColors = {
  Founder: {
    bg: 'bg-purple-100',
    text: 'text-purple-700',
    border: 'border-purple-300',
    badge: 'bg-purple-600 text-white',
    gradient: 'from-purple-500 to-purple-700',
    hex: '#9333EA'
  },
  Titanium: {
    bg: 'bg-slate-100',
    text: 'text-slate-700',
    border: 'border-slate-300',
    badge: 'bg-slate-600 text-white',
    gradient: 'from-slate-500 to-slate-700',
    hex: '#475569'
  },
  Rhodium: {
    bg: 'bg-gray-100',
    text: 'text-gray-700',
    border: 'border-gray-300',
    badge: 'bg-gray-600 text-white',
    gradient: 'from-gray-500 to-gray-700',
    hex: '#6B7280'
  },
  Platinum: {
    bg: 'bg-cyan-100',
    text: 'text-cyan-700',
    border: 'border-cyan-300',
    badge: 'bg-cyan-600 text-white',
    gradient: 'from-cyan-500 to-cyan-700',
    hex: '#0891B2'
  },
  Gold: {
    bg: 'bg-amber-100',
    text: 'text-amber-700',
    border: 'border-amber-300',
    badge: 'bg-amber-600 text-white',
    gradient: 'from-amber-500 to-amber-700',
    hex: '#D97706'
  },
  Silver: {
    bg: 'bg-zinc-100',
    text: 'text-zinc-700',
    border: 'border-zinc-300',
    badge: 'bg-zinc-600 text-white',
    gradient: 'from-zinc-500 to-zinc-700',
    hex: '#71717A'
  }
};

export const normalizeTierName = (tier) => {
  const normalized = String(tier || '')
    .trim()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+member$/i, '')
    .replace(/\s+/g, ' ')
    .toLowerCase();

  return Object.keys(tierColors).find((key) => key.toLowerCase() === normalized) || 'Silver';
};

export const getTierColor = (tier) => {
  return tierColors[normalizeTierName(tier)] || tierColors.Silver;
};
